<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" ref="buttonauthList" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<buttonauthForm ref="buttonauthForm" :row="currentrow" @success="buttonauthSubmit" />
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import buttonauthForm from './form.vue'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				currentrow:{},
				modal_model:false,
				modal_title: '其他按钮权限',
				modal_width:1200,
				modal_height:800,
				list_formConfig: [{
						field: 'a',
						title: 'A',
						itemRender: {
							name: '$input'
						}
					}
				],
				list_columns: [
					{
						field: 'code',
						title: '模块编码',
					},
					{
						field: 'name',
						title: '模块名称'
					},
					{
						field: 'commit_time',
						title: '创建时间',
						formatter: 'datetime'
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 120,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>
								]
							}
						}
					}					
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.formConfig = false
				
				gridOptions.toolbarConfig.buttons = [{
					name: '新增',
					status: 'primary',
					code: 'add'
				}]
			},
			add(){
				this.currentrow = {}
				this.$nextTick(()=>{
					this.$refs.buttonauthForm.modal_show()
				})
			},
			edit(row){
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.buttonauthForm.modal_show()
				})
				
			},
			customreload(){
				this.$refs.buttonauthList.commitProxy('query')
			},
			delete(row){
				this.$confirm('是否确认删除', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.buttonauth.delete(row.id).then(() => {
						this.loading = false
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					},()=>{
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})
			},
			buttonauthSubmit(){
				this.customreload()
			},
			list() {
				return new Promise((resolve) => {
					this.$api.buttonauth.list().then((res) => {
						resolve(res)
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			buttonauthForm
		}
	}
</script>